
import { defineComponent } from "vue";
import { Account } from "@/types/";
import UserTag from "./UserTag.vue";

export default defineComponent({
  name: "ActionsModal",
  components: {
    UserTag,
  },
  props: {
    isVisible: Boolean,
    action: {
      type: String,
      required: true,
    },
    selectedUsers: Array as () => Account[],
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    onRemoveSelected(id: string) {
      this.$emit("removeSelected", id);
    },
    cancelAction() {
      this.$emit("cancelAction");
    },
  },
});
